import JSON5 from 'json5';
// at this time, we replace every newline, tab and return carier character
// we can add more if any new character need to be replaced
const REPLACE_REG = /(\r|\t|\n|\r)/gm;
/** 
 * This function returns a string that has been replaced some of special characters: newline, tab, carier
 * In case there is any errors occured, return defaultValue
 * Error feed example :http://api.ddev1.worldnow.com/feed/v3.0/widgets/200588?alt=json#
 * @param {Object} text - The original text will be replaced
 * @param {Object} replacedBy - The new string to replace
 * @param {Object} defaultValue - The default value
 * @return {Object} return object.
*/
const replaceSpecialChars = (text, replacedBy, defaultValue) => {
  let result = defaultValue;
  try {
    result = text.replace(REPLACE_REG, replacedBy);
  } catch (e) {
    console.log('JsonUtils.replaceSpecialChars', e);
  }
  return result;
};

/** 
 * This function converts a Javascript Object Notation (JSON) string into an object. 
 * In case there is any errors occured, return defaultValue
 * @param {Object} jsonString - The JSON string will be converted
 * @param {Object} defaultValue - The default value
 * @return {Object} return object
*/
const parseJson = (jsonString, defaultValue) => {
  let result = defaultValue;
  try {
    result = JSON5.parse(jsonString);
  } catch (e) {
    console.log('JsonUtils.parseJson', e);
  }
  return result;
};

export { replaceSpecialChars, parseJson };



// WEBPACK FOOTER //
// ./app/utils/JsonUtils.js